import { prefixZero } from "@covertree/utils";

import { createInput } from "./createInput";

export const Month = createInput({
  sx: (theme) => ({
    width: theme.spacing(10),
  }),
  customOnBlur: (e, { zeroPrefixDisabled, updater }) => {
    if (!zeroPrefixDisabled) {
      updater(prefixZero(e.target.value));
    }
  },
  fieldName: "month",
  updaterName: "changeMonth",
  maxLength: 2,
});
